import { useAtomValue } from "jotai";
import { useDocumentsFeatureOptional } from "web_myplann/Api/Rights/RightsProvider";
import { timelineFilterAtom } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { isTimelineFilterDefault } from "web_myplann/NotificationCenter/Utils/isTimelineFilterDefault";

export const useIsTimelineFilterDefault = (): boolean => {
	const filter = useAtomValue(timelineFilterAtom);
	const hasDocumentsFeature = useDocumentsFeatureOptional();
	return isTimelineFilterDefault(filter, hasDocumentsFeature);
};
